module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg_with_news.0399d851.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg_with_news.jpg
// module id = 3034
// module chunks = 11